<template>
    <div class="box">
        <div class="user_bor">


            <div class="user_box">
                <div class="user_box_left">
                    {{$t('m.RetrievePWD_01')}}
                </div>
                <div class="user_box_right">

                </div>

            </div>
            <template v-if="!showbox">
                <div class="from_box">
                    <div class="inpu_box">
                        <div class="inpu_title">
                            {{$t('m.RetrievePWD_02')}}
                        </div>
                        <div class="inpu_main">
                            
                            <el-input  :type="password_type1" :show-password="false" v-model="param.password" :placeholder="$t('m.RetrievePWD_05')"></el-input>
							<img v-if="password_type1=='text'" src="../../static/eye1.png" @click="password_type_c(0)" alt="">
							<img v-else src="../../static/eye2.png" @click="password_type_c(0)" alt="">
							
                        </div>
                    </div>
                    <div class="inpu_box">
                        <div class="inpu_title">
                            {{$t('m.RetrievePWD_03')}}
                        </div>
                        <div class="inpu_main">
                            <el-input :type="password_type2" :show-password="false" v-model="param.password2" :placeholder="$t('m.RetrievePWD_06')"></el-input>
							
							<img v-if="password_type2=='text'" src="../../static/eye1.png" @click="password_type_c(1)" alt="">
							<img v-else src="../../static/eye2.png" @click="password_type_c(1)" alt="">
                        </div>
                    </div>
                </div>
                <div class="btnbox">
                    <el-button type="danger" @click="confirm">{{$t('m.RetrievePWD_04')}}</el-button>
                </div>
                <div class="kongbox"></div>
            </template>

            <template v-else>
                <div class="Retrieve">
                    <img src="../../static/suo_icon.png" alt="">
                    <div class="mailbox">
                        {{user_data.email}}
                    </div>
                    <div class="Retrieve_text">
                        {{$t('m.RetrievePWD_07')}}
                    </div>
                </div>
            </template>




        </div>










    </div>
</template>
<script>
import encryption from '@/utils/encryption.js'

export default {
    components: {

    },
    data() {
        return {
            showbox: false,
            param: {
                password:'',
                password2:'',
                user_id:'',
				

            },
			password_type1:'password',
			password_type2:'password',
			user_data:'',
        }
    },
    created() {

    },
    mounted() {
        let user_data = JSON.parse(localStorage.getItem('user_data'))
        this.user_data = user_data
        this.param.user_id = user_data.id
		console.log(user_data)
    },
    methods: {
		password_type_c(idx){
			console.log(idx)
			if(idx){
				if(this.password_type2=='password'){
					this.password_type2 = 'text'
				}else{
					this.password_type2 = 'password'
				}
				console.log(this.password_type2)
			}else{
				if(this.password_type1=='password'){
					this.password_type1 = 'text'
				}else{
					this.password_type1 = 'password'
				}
			}
		},
        //找回密码
        confirm() {
            
            let sing = encryption.getSing(this.param)
            if (!this.param.password) {
                this.$message.warning(this.$t('m.RetrievePWD_05'))
            } else if (!this.param.password) {
                this.$message.warning(this.$t('m.RetrievePWD_06'))
            } else if (this.param.password != this.param.password2) {
                this.$message.warning(this.$t('m.RetrievePWD_08'))
            } else {
                this.$api.pwd_edit(this.param,sing).then((res)=>{
                    if(res.data.code == 1){
                        this.showbox = true
                    }
                })
                
            }
        }

    }
}
</script>
<style lang="scss" scoped>
// .box{
//     min-width: 800px;
// }
.user_box {
    display: flex;
    align-items: center;
    justify-content: space-between;
    border-left: 5px solid #ef5843;
    height: 26px;
    padding-right: 30px;
    padding-left: 20px;
    .user_box_left {
        padding-left: 25px;
    }

}


.from_box {
    margin: 0 auto;
    margin-top: 50px;
    max-width: 520px;
}

.inpu_box {
    border: 1px solid #e5e5e5;
    width: 100%;
    margin-top: 20px;
    background-color: #f6f7fa;
    display: flex;
    align-items: center;
    border-radius: 4px;
    padding: 0 30px;
    height: 50px;
    line-height: 50px;
	justify-content: space-between;
    .inpu_title {
       
        // width: 100px;
		// padding: 0 20px;
        font-size: 14px;
        font-weight: bold;
    }

    .inpu_main {
		width: 280px;
        margin-left: 10px;
        // flex: 1;
		position: relative;
		img{
			position: absolute;
			width: 20px;
			height: 20px;
			top: 50%;
			transform:translateY(-50%);
			right: -20px;
		}
        ::v-deep .el-input__inner {
            border: 0 !important;
            background-color: #f6f7fa;
        }
    }
}
.kongbox{
    height: 30px;
}
.btnbox {
    text-align: center;
    margin-top: 40px;

    ::v-deep .el-button {
        width: 180px !important;
        height: 54px !important;
        background-color: #ef5843;
        font-weight: bold;
        font-size: 14px;
    }
}
.Retrieve{
    text-align: center;
    padding: 30px 0 50px 0;
    img{
        width: 60px;
        height: 60px;
    }
    .mailbox{
        font-size: 20px;
        font-weight: bold;
        margin-top: 20px;
    }
    .Retrieve_text{
        font-size: 14px;
        margin-top: 20px;
    }
}



// 宽度小于1200px
@media screen and (max-width: 1200px){
	.user_box{padding: 0;}
	.from_box{
		margin: 0 0.6rem;
		margin-top: 1rem;
		.inpu_box{
			height: auto;
			padding: 0rem 0.6rem;
			display: block;
			position: relative;
			.inpu_title{
				// line-height: 40px!important;
				line-height:normal!important;
				padding-top: 0.8rem;
			}
			.inpu_main{
				img{
					// position: absolute;
					// top: 1rem;
					// right: 1rem;
					top: 50%;
					transform: translateY(-50%);
					right: 0	;
				}
				width: 100%;
				margin-left: 0;
				::v-deep.el-input__inner{
					padding: 0;
				}
			}
		}
	}
}


</style>